// @ts-check
import * as React from "react"
import loadable from "@loadable/component"

import RootProvider from "./src/@reditor/Provider"
import LayoutContainer from "./src/containers/layout-container"
import LoginAdminPage from "./src/pages/login-admin"
import {navigate} from "gatsby"

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import "./src/styles/global.css"
const PreviewLayoutContainer = loadable(() =>
  import("./src/containers/preview-layout-container"),
)

/**
 * @type {import('gatsby').GatsbyBrowser["wrapPageElement"]}
 */
export const wrapPageElement = ({element, props, ...others}) => {
  let isAdminLoginSuccess = typeof window !== 'undefined' && window.sessionStorage ? sessionStorage.getItem('adminLogin') : '';
  let hostNames = ["localhost","staging.dropthought.com","dt-lite.com"]
  let currentHostName = window.location.hostname
  let pathName = window.location.pathname
  let DTApiKey
  let businessUUID
  let DTPlanID
  if (hostNames.includes(currentHostName) && isAdminLoginSuccess !== 'true') {
    return <LoginAdminPage />
  }
  if (props.pageContext.static){
    return <LayoutContainer pageProps={props}>{element}</LayoutContainer>
  }
  // if (pathName.includes('/addNewClient/1') || pathName.includes('/addNewClient/2') || pathName.includes('/addNewClient/3') || pathName.includes('/addNewClient/4')) {
  //   let parts = pathName.split('/');
  //   let index = parts.indexOf('addNewClient');
  //   DTApiKey = parts[index + 2];
  //   businessUUID = parts[index + 3];
  //   DTPlanID = parts[index + 1];
  //   localStorage.setItem('DTApiKey',DTApiKey)
  //   localStorage.setItem('businessUUID',businessUUID)
  //   localStorage.setItem('planId',DTPlanID)
  //   localStorage.setItem('apiKey',DTApiKey)
  //   localStorage.setItem('planName', 'DT lite Pro');
	// 	localStorage.setItem('planPrice', String(99));
  //   localStorage.setItem('planUpgrade', 'true');
  //   navigate('/addNewClient');
  // }
  else
    {
      return (
      <PreviewLayoutContainer pageProps={props}>
        {element}
      </PreviewLayoutContainer>
    )}
}

/**
 * @type {import('gatsby').GatsbyBrowser["wrapRootElement"]}
 */
export const wrapRootElement = ({element, ...props}) => {
  // call config here?
  return <RootProvider>{element}</RootProvider>
}

export const onClientEntry = () => {
  window.addEventListener('beforeunload', () => {
    localStorage.clear();
  });
};